module.exports = __webpack_public_path__ + "img/Feature.e8d0257a.png";